import React from "react";
import "./index.css";

const rules = [
  {
    title: "Check-In",
    value: "14:00",
  },
  {
    title: "Check-Out",
    value: "10:00",
  },
  {
    title: "Children Policy",
    value: "All Ages",
  },
  {
    title: "Smoking & Substances",
    value: "Not Allowed",
  },
  {
    title: "Pet Policy",
    value: "Not Allowed",
  },
  {
    title: "Alcohol Policy",
    value: "Allowed",
  },
  {
    title: "Villa Staff",
    value: "Villa cook, 2 daytime housekeepers, and gardener",
  },
  {
    title: "Accompanying Guest’s Staff",
    value: "Max 1, price includes meals",
  },
  {
    title: "Extra Guest",
    value: "Max 2",
  },
  {
    title: "Parties and Events",
    value: "Not Allowed",
  },
  {
    title: "Music",
    value: "Allowed",
  },
];

const HouseRules = () => {
  return (
    <section className="house-rules-section">
      <h2 className="house-rules-title">House Rules</h2>
      <div className="rules-container">
        {rules.map((rule, index) => (
          <div className="rule-box" key={index}>
            <p className="rule-title">{rule.title}</p>
            <p className="rule-value">{rule.value}</p>
          </div>
        ))}
      </div>
    </section>
  );
};

export default HouseRules;
